<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <help :text="$t('help.groups')" :title="$t('help.groups_title')"/>

    <filters
      class="white-container"
      v-if="filters"
      :inputs="filters"
      @filter="filter"
      :extended="true"
      :loading="loading"
    >
    </filters>

    <div class="position-relative">

      <loader v-if="loading"/>

      <v-server-table
        ref="appTable"
        name="groupSubTable"
        class="white-container"
        url="/admin/teams"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true">

        <template slot="beforeFilter">
          <b-row>
            <b-col>
              <router-link to="groups/create">
                <b-button
                  class="px-4"
                >{{ $t('groups.add_new_group') }}
                </b-button>
              </router-link>
            </b-col>
          </b-row>
        </template>

        <template slot="id" slot-scope="props">
          <router-link :to="{path: `/groups/edit/${props.row.id}`, params: props.row}" target="_blank">
            {{ props.row.id }}
          </router-link>
        </template>
        
        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{$t('global.showing')}}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
        </template>

        <template slot="location" slot-scope="props">
          <column-location :row="props.row"/>
        </template>
        <template slot="active" slot-scope="props">
          <column-check :row="props.row" column="active" />
        </template>
        <template slot="subscription_end_date" slot-scope="props">
          <column-date :row="props.row" column="subscription_end_date" format="L"/>
        </template>
        <template slot="actions" slot-scope="props">
          <column-action
            :deleteUrl="`/teams/${props.row.id}`"
            @deleteItems="refreshTable('appTable')"
            :route="{path: `/groups/edit/${props.row.id}`, params: {id: props.row.id}}"
          />
        </template>

      </v-server-table>
    </div>
  </div>

</template>

<script>
  import axios from '@/utils/axios';
  import {Event} from 'vue-tables-2';
  import usersFilters from './teamsFilters.js';
  import filters from '@/components/global/filters';
  import i18n from "@/utils/i18n"

  export default {
    middleware: 'auth',
    name: 'Users',
    components: {
      filters
    },
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        params: {
          page: 1,
          filter: {}
        },
        columns: ['id', 'name', 'description', 'users_count', 'member_limit', 'type', 'active', 'subscription_end_date', 'actions'],
        filters: usersFilters,
        options: {
          skin: [],
          headings: {
            id: '#',
            name: i18n.t('form.name'),
            description: i18n.t('form.description'),
            users_count: i18n.t('groups.number_of_users'),
            member_limit: i18n.t('groups.max_number_of_users'),
            type: i18n.t('groups.group_type'),
            actions: i18n.t('global.actions'),
            active: i18n.t('form.active'),
            subscription_end_date: i18n.t('form.renewal_date'),
          },
          sortable: [],
          dateColumns: ['created_at', 'updated_at'],
          filterByColumn: false,
          columnsDropdown: false,
          customFilters: ['custom'],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: {
                limit: data.limit,
                filter: data.custom,
                page: data.page,
                order: 'count',
                sort: 'desc'
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      Event.$on('vue-tables.groupSubTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
      });
    },
    methods: {
      filter(params) {
        this.params = params;
        Event.$emit('vue-tables.groupSubTable.filter::custom', params)
      }
    },
    destroyed() {
      Event.$off('vue-tables.groupSubTable.loaded');
    }
  }
</script>
